export default "/images/b55ba97edd694932f551526fce40b500.png";